<div class="student-tab student-tab-classes">
    <div class="student-tab__header">
        <span class="student-tab__text">Join a class:</span>
        <form
            #f="ngForm"
            novalidate
            name="joinClassForm"
            (ngSubmit)="submitJoinClass($event, rosterCodeInput)"
        >
            <input
                [(ngModel)]="rosterCode"
                name="rosterCode"
                #rosterCodeInput="ngModel"
                pattern="[a-zA-Z0-9]+"
                type="text"
                class="student-tab__input"
                placeholder="Enter code e.g., 1234banana"
                required
            />
            <input
                id="join-btn"
                type="submit"
                value="Go"
                class="student-tab__button btn"
            />
        </form>
        <p *ngIf="f.submitted && !rosterCodeInput.dirty">
            This field is required.
        </p>
        <p
            *ngIf="
                f.submitted && rosterCodeInput.dirty && rosterCodeInput.invalid
            "
        >
            Invalid roster code.
        </p>
    </div>
    <div class="student-tab__body">
        <div class="row classListing__header tableListing__header">
            <div class="col-xs-5 col-tablet-5 col-md-6 col-lg-6">
                Class Name
            </div>
            <div class="col-xs-5 col-tablet-5 col-md-4 col-lg-4">Teacher</div>
            <div
                class="tableListing__header__edit col-xs-2 col-tablet-2 col-md-2 col-lg-2"
            >
                Delete
            </div>
        </div>

        <div class="tableListing__row__empty" *ngIf="classes.length === 0">
            <span
                >You have not joined any classes. Enter a code to join a
                class.</span
            >
        </div>

        <div
            class="row classListing__row tableListing__row"
            *ngFor="let studentClass of classes"
        >
            <div
                class="tableListing__row__name col-xs-5 col-tablet-5 col-md-6 col-lg-6"
            >
                {{ studentClass.name | safeTruncate: 40 }}
            </div>
            <div
                class="tableListing__row__name col-xs-5 col-tablet-5 col-md-4 col-lg-4"
            >
                {{ studentClass.teacher_name | safeTruncate: 40 }}
            </div>
            <div
                class="tableListing__row__delete col-xs-2 col-tablet-2 col-md-2 col-lg-2"
            >
                <a
                    href="#"
                    role="button"
                    aria-label="delete"
                    (click)="leaveClass($event, studentClass)"
                >
                    <i class="lm lm-trash"></i>
                </a>
            </div>
        </div>
    </div>
</div>
